<template>
	<section class="press page text-center">

    <loading />

    <ul class="mauto w90 text-left">
      <li v-for="(item, index) in news"
          :key="index">
        <h2>{{ item.title }}</h2>
        <span>{{ item.date }}</span>
        <figure class="w100 mtop10px">
          <img v-if="isImg"
               class="w100"
               :src="require('../assets/news/' + item.img +'.jpg')"
               alt="articol pic">
        </figure>
        <article v-html="item.text"></article>
        <article v-html="item.distribution"></article>
        <hr>
      </li>
    </ul>

	</section>
</template>

<script>
  import Loading from '../components/Loading'
	import { mapState } from 'vuex'
	export default {
		name: 'press',
		data () {
			return {
        isImg: true,
        imgNames: []
			}
		},
		computed: {
			...mapState({
        news: 'news'
      })
		},
		methods: {
      addFile (e, id, index) {
        const formData = new FormData()
        const file = e.target.files[0]
        formData.append('file', file)
        formData.append('id', id)
        const clbk = name => {
          this.imgNames[index] = name
          this.isImg = true
        }
        this.$store.dispatch('add_news_img', {formData, clbk})
        this.isImg = false
      }
		},
    components: {
      Loading
    }
	}
</script>

<style lang="less">
	.press {
    padding: 100px 0 120px;
    ul {
      max-width: 600px;
    }
    a {
      font-size: 2rem;
    }
    a:hover {
      color: #50c607;
    }
	}
</style>